export default __webpack_public_path__ + "static/media/monthly-raffle-banner.db41a0ce.png";